import React, { useState } from 'react';
import fileStackClient from '@app/filestack';
import { UploadArea } from '@brokerbay/elements-web';
import { isValidUrl } from 'utils';
import LockboxPhotoEditor from '../../../app/react-common/LockboxPhotoEditor';

type UploadEditPhotoButtonProps = {
  listingId: string;
  lockboxPhoto?: string | null;
  setLockboxPhoto: (url: string) => void;
};

const UploadEditPhotoButton: React.FC<UploadEditPhotoButtonProps> = ({
  listingId,
  lockboxPhoto,
  setLockboxPhoto,
}) => {
  const [showLockboxPhotoEditor, setShowLockboxPhotoEditor] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [uploadedLockboxPhoto, setUploadedLockboxPhoto] = useState<string>();

  const uploadPhoto = () => new Promise<string | null>(resolve => {
      const picker = fileStackClient.picker({
        maxFiles: 1,
        accept: 'image/*',
        uploadInBackground: false,
        onFileSelected: file => {
          if (file.source === 'url' && !isValidUrl(file.originalPath))
            throw new Error('Invalid URL format. Please try again.');
        },
        onUploadDone: result => {
          if (result.filesUploaded?.length) {
            const attachment = result.filesUploaded[0];

            resolve(attachment.url);
          }
          resolve(null);
        },
      });

      picker.open();
    });

  const closeModal = () => setShowLockboxPhotoEditor(false);
  const onSave = (photo: string) => {
    setLockboxPhoto(photo);
    closeModal();
  };
  const onButtonClick = async () => {
    if (lockboxPhoto) {
      setIsEditMode(true);
      setUploadedLockboxPhoto(lockboxPhoto);
    } else {
      setIsEditMode(false);
      const photo = await uploadPhoto();
      if (!photo) return;
      setUploadedLockboxPhoto(photo);
    }
    setShowLockboxPhotoEditor(true);
  };

  return (
    <>
      <UploadArea
        icon="cameraOutlined"
        onClick={onButtonClick}
        dataCy="showing-notification-upload-area"
      >
        {lockboxPhoto ? 'Edit / Delete' : 'Add Lock Box'} Photo
      </UploadArea>
      <LockboxPhotoEditor
        listingId={listingId}
        visible={showLockboxPhotoEditor}
        closeModal={closeModal}
        onSave={onSave}
        lockboxPhoto={uploadedLockboxPhoto || ''}
        isRemovable={isEditMode}
      />
    </>
  );
};

export default UploadEditPhotoButton;
